import { create } from 'zustand';

import { IGetSharedEntityResponse } from '../../modules/shared-entities/types/sharedEntities.types';
import { IUseSharedEntitystore } from './sharedEntities.types';

export const initialState = {
  sharedEntity: undefined,
  isOpenLoginModal: false,
  previousUrl: undefined,
};

const useSharedEntitystore = create<IUseSharedEntitystore>((set) => ({
  ...initialState,
  sharedEntity: undefined,
  isOpenLoginModal: false,
  previousUrl: undefined,
  setPreviousUrl: (url?: string) => set({ previousUrl: url }),
  handleChangeIsOpenLoginModal: (flag: boolean) => set({ isOpenLoginModal: flag }),
  handleChangeSharedEntity: (sharedEntity?: IGetSharedEntityResponse) => set({ sharedEntity }),
  reset: () => set({ ...initialState }),
}));

export default useSharedEntitystore;
